export enum MessageType {
  DEBUG,
  INFO,
  WARN,
  ERROR,
}

export interface Message<T extends MessageType> {
  type: T;
  text: string;
  error: T extends MessageType.ERROR ? Error : undefined;
  metadata: any[];
}

export type Handler = (message: Message<MessageType>) => void;

export class Log {
  private handlers: Handler[];

  constructor(...handlers: Handler[]) {
    this.handlers = handlers;
  }

  public subscribe = (subscriber: Handler): (() => void) => {
    this.handlers.push(subscriber);
    return () => {
      this.handlers.splice(this.handlers.indexOf(subscriber), 1);
    };
  };

  public publish = <T extends MessageType>(message: Message<T>) => {
    for (const subscriber of this.handlers) {
      subscriber(message);
    }
  };

  public debug = (text: string, ...metadata: any[]) => {
    this.publish({
      type: MessageType.DEBUG,
      text,
      metadata,
      error: undefined,
    });
  };

  public info = (text: string, ...metadata: any[]) => {
    this.publish({
      type: MessageType.INFO,
      text,
      metadata,
      error: undefined,
    });
  };

  public warn = (text: string, ...metadata: any[]) => {
    this.publish({
      type: MessageType.WARN,
      text,
      metadata,
      error: undefined,
    });
  };

  public error = (text: string, error: Error, ...metadata: any[]) => {
    this.publish({
      type: MessageType.ERROR,
      text,
      metadata,
      error,
    });
  };
}
